<kt-base-modal [title]="isEdit ? 'Edit Handover Note' : 'Add Handover Note'">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <form>
        <div class="row max-height">
          <div class="form-group col-md-12">
            <kt-select [field]="formControl.hand_over_note_fk_client_id" [form]="form" [options]="lookup.client"
              [values]="shiftDetail?.client?.client_id || []" (valueChange)="valueChangeHandler($event)">
            </kt-select>
          </div>
          <div class="form-group col-md-12">
            <kt-select [field]="formControl.hand_over_note_fk_location_id" [form]="form" [options]="lookup.location"
              [values]="shiftDetail?.location?.location_id || []" (valueChange)="valueChangeHandler($event)">
            </kt-select>
          </div>
          <div class="form-group col-md-12">
            <kt-select [field]="formControl.hand_over_note_area_ids" [form]="form" [options]="lookup.area"
              [values]="shiftDetail?.area?.area_id || []">
            </kt-select>
          </div>
          <div class="form-group col-md-12">
            <kt-datepicker [field]="formControl.hand_over_note_expired_at" [form]="form" [options]="" [values]="">
            </kt-datepicker>
          </div>
          <div class="form-group col-md-12">
            <kt-text-editor [field]="formControl.hand_over_note_text" [form]="form" [values]="''">
            </kt-text-editor>
          </div>
          <div class="form-group col-md-12">
            <kt-file-upload [field]="formControl.file_upload" [form]="form" [values]="">
            </kt-file-upload>
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn btn-brand" (click)="submitClickHandler()">{{ this.isEdit ? 'Update' : 'Submit'
          }}</button>
      </div>
    </kt-loader>
  </div>
</kt-base-modal>
